import * as React from "react";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import { fetchAssetVulnerabilities } from "security-app/hooks/api/assetsAPI";
import columnRenderers from "./column-renderers";
import { TABLE_LAYOUT } from "./constants";
function VulnerabilitiesInfo({ assetId }) {
  const fetchEntities = (searchParams) => fetchAssetVulnerabilities(assetId, searchParams);
  const keyFn = (searchParams) => ["assets", assetId, "vulnerabilities", searchParams];
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "vulnerabilities",
      tableLayout: TABLE_LAYOUT,
      fetchEntities,
      keyFn,
      entityAttributesAreCamelCase: false,
      columnRenderers,
      searchPlaceholder: "Search vulnerabilities",
      withoutURLParams: true,
      compactView: true
    }
  );
}
export default VulnerabilitiesInfo;
